// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Yt-z","tooltipWrapper":"Zt-z","icon":"_t-z","tooltip":"au-z","content":"bu-z"};